---
fr:
  follow_up:
    achived_price: Prix obtenu
    actual: Actuel
    buy_production: Achat de production
    cannibalism: Cannibalisation
    charts:
      capture_rates: Taux de capture
      captured_prices: Prix capturés
      consumption: Consommation
      cumulative_production: Production cumulative
      cumulative_total_revenue: Revenu total cumulatif
      full_load_factor: Facteur de charge complet
      production: Production
      revenue: Revenu
      revenues_phyiscal_financial: Revenus des règlements physiques et financiers
      revenues_variable_fixed: Revenus des règlements variables et fixes
      risk_and_cannibalism: Risques et cannibalisation
      spot_price: Prix au comptant
      volume: Volume
    consumption: Consommation
    consumption_tab:
      paid: Payé
      spot: Au comptant
    contracted: Contracté
    financial: Financier
    fixed: Fixe
    header: Examen des performances
    hedge: Couverture
    index: Indice
    merchant: Marchand
    merchant_base_value: Valeur de base du marchand
    net: Valeur nette
    overproduction: Surproduction
    overview:
      actual: Actuel
      expected: Attendu
      full_load_factor: Facteur de charge complet
      hedged_price: Prix couvert
      hedged_volume: Volume couvert
      production: Production
    p50: p50
    physical: Physique
    ref: Référence
    revenues:
      contracted_sales_revenue: Revenu de vente contracté
      fixed_revenues: Revenus fixes
      physical_sales_revenue: Revenu de vente physique
      variable_revenues: Revenus variables
    risk:
      overproduction_risk: Risque de surproduction
      production_shortfall: Risque de déficit de production
    sell_production: Vente de production
    shared:
      captured: Capturé
      revenue: Revenu
      total: Total
    shortfall: Déficit
    spot_price: Prix au comptant
    total: Total
    variable: Variable
    volume: Volume
